import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  inject,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  DialogService,
  DynamicDialogRef,
} from '../../../../core/services/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '../../../pipes/translate/translate.pipe';
import { IcChevronDownComponent } from '../../Icons/ic-chevron-down/ic-chevron-down';
import { WidgetMenuContentComponent } from '../widget-menu-content/widget-menu-content.component';

/**
 * WidgetMenuComponent component.
 * Provides UI presentation and event handling for widget menu component.
 */
@Component({
  selector: 'app-widget-menu',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    IcChevronDownComponent,
    TranslatePipe,
  ],
  templateUrl: './widget-menu.component.html',
  styleUrl: './widget-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class WidgetMenuComponent {
  /** Injected service for dialog service. */
  private dialogService = inject(DialogService);
  /** Property ref. */
  private ref: DynamicDialogRef<WidgetMenuContentComponent> | undefined | null;

  /**
   * Handles toggle menu logic.
   */
  toggleMenu() {
    if (this.ref) {
      this.ref.close();
      this.ref = undefined;
      return;
    }

    this.ref = this.dialogService.open(WidgetMenuContentComponent, {
      header: '',
      width: '1250px',
      contentStyle: { padding: '0', borderRadius: '24px' },
      baseZIndex: 10000,
      modal: true,
      styleClass: 'widget-menu-dynamic-dialog',
      maskStyleClass: 'widget-menu-mask',
      dismissableMask: true,
      closable: true,
      showHeader: false,
      closeOnEscape: true,
      transitionOptions: '0ms',
    });

    if (this.ref) {
      this.ref.onClose.subscribe(() => {
        this.ref = undefined;
      });
    }
  }

  /**
   * Handles handle keyboard event logic.
   * @param event - The event
   */
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const isTyping =
      ['INPUT', 'TEXTAREA'].includes((event.target as HTMLElement).tagName) ||
      (event.target as HTMLElement).isContentEditable;

    if (isTyping) return;

    // Shift + W
    if (
      event.shiftKey &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.altKey &&
      event.key.toLowerCase() === 'w'
    ) {
      event.preventDefault();
      this.toggleMenu();
    }
  }
}
